import { Typography, useTheme } from '@mui/material';
import Iconify from 'src/components/Iconify';
import { ListItemIconStyle, ListItemStyle } from 'src/components/nav-section/vertical/style';
import useSettingLayoutStore from 'src/store/settingLayout';

const NavSettingsLayout = ({ isCollapse }) => {
  const theme = useTheme();
  const { setIsOpen } = useSettingLayoutStore();

  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <ListItemStyle LinkComponent={'button'} sx={{ color: theme.palette.grey[isDarkMode ? 400 : 700] }} onClick={() => setIsOpen(true)}>
      <ListItemIconStyle>
        <Iconify icon={'solar:settings-broken'} />
      </ListItemIconStyle>
      <Typography sx={{ width: isCollapse ? '0px' : 'auto', opacity: isCollapse ? '0' : '1', whiteSpace: 'nowrap', fontSize: '14px' }}>
        شخصی سازی پنل
      </Typography>
    </ListItemStyle>
  );
};

export default NavSettingsLayout;
